<template>
  <div
    :class="[
      'app-container',
      `layout-${layoutStore.routeLayout}`,
      layoutStore.layoutClass?.layout,
      layoutStore.routeLayout === 'activityH5' && !isApp() ? 'layout-activity-pt' : ''
    ]"
  >
    <el-config-provider :locale="elLocale">
      <router-view
        :key="route.fullPath"
        :class="[
          layoutStore.layoutClass?.header, { 'hidden-header': isApp() }
        ]"
        name="header"
        v-bind="headerProps"
      />
      <router-view
        :key="route.fullPath"
        v-bind="layoutStore.routeProps?.default"
      />
      <router-view
        :key="route.fullPath"
        :class="layoutStore.layoutClass?.footer"
        name="footer"
        v-bind="layoutStore.routeProps?.footer"
      />
    </el-config-provider>

    <!-- 消息提醒 -->
    <MessageUnread v-if="userStore.isLogin" />
    <UniversalPop />
    <Drogue v-if="popupStore.droguePop" />
    <ChatWindow v-if="imStore.showIm" />
    <ChatWindowApply />
  </div>
</template>

<script setup lang="ts">
import { useWindowScroll } from '@vueuse/core';
import { getCurrentLocale } from '@/lang/element';
import { useLayoutStore } from '@/store/layout';
import { getOriginPath } from '@/lang/i18n';
import { useImStore } from '@/store/im';
import { useUserStore } from '@/store/User';
import { isApp } from '@/utils/tools';
import { usePopupStore } from '@/store/popup';
const MessageUnread = defineAsyncComponent(() => import('@/components/message/MessageUnread.vue'));
const Drogue = defineAsyncComponent(() => import('@c/common/Drogue.vue'));
const UniversalPop = defineAsyncComponent(() => import('@c/common/UniversalPop.vue'));
const ChatWindow =   defineAsyncComponent(() => import('@/components/im/ChatWindow.vue'));
const ChatWindowApply = defineAsyncComponent(() => import('@/components/im/ChatWindowApply.vue'));

const imStore = useImStore();
const route = useRoute();
const layoutStore = useLayoutStore();
const userStore = useUserStore();
const popupStore = usePopupStore();
const { locale } = useI18n();
// 当前element对应语言的语言包
const elLocale = computed(() => getCurrentLocale(locale.value));
// header 主题
const headerTheme = ref('');

// header参数
const headerProps = computed(() => {
  // 目前首页需要header吸顶
  if (getOriginPath(route?.matched[0]?.path) === '/') {
    return {
      ...layoutStore.routeProps.header,
      border: headerTheme.value === 'light',
      fixed: true
    };
  }

  return {
    ...layoutStore.routeProps.header,
    fixed: true,
    border: Object.keys(layoutStore.routeProps?.header || {}).includes('border') ? layoutStore.headerFixed : true
  };
});

const { y } = useWindowScroll();
watch(y, value => {
  if (getOriginPath(route.matched[0].path) === '/') {
    if (value < 499) {
      headerTheme.value = 'dark';
    } else {
      headerTheme.value = 'light';
    }
  }

  layoutStore.headerFixed = value > 10;
});

</script>
<style lang="scss" scoped>

.layout-activityH5{
  max-width: 100vw;
  width: 100vw;
  &.layout-activity-pt {
    padding-top: 48px;
  }
  .hidden-header {
    display: none;
  }
}
</style>
